// Date / time formatters used across the app.
// Dates → MM-DD-YYYY. Times → 12-hour with AM/PM.

function pad(n) { return String(n).padStart(2, "0"); }

// Accepts "YYYY-MM-DD", ISO datetime, or Date object.
export function fmtDate(input) {
  if (!input) return "";
  let d;
  if (input instanceof Date) d = input;
  else if (typeof input === "string") {
    // Plain YYYY-MM-DD → parse as local
    const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(input);
    if (m) d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
    else d = new Date(input);
  } else return "";
  if (isNaN(d.getTime())) return String(input);
  return `${pad(d.getMonth() + 1)}-${pad(d.getDate())}-${d.getFullYear()}`;
}

// Accepts "HH:MM" (24h). Returns "h:MM AM/PM".
export function fmtTime(input) {
  if (!input) return "";
  const m = /^(\d{1,2}):(\d{2})/.exec(String(input));
  if (!m) return String(input);
  let h = Number(m[1]);
  const min = m[2];
  const period = h >= 12 ? "PM" : "AM";
  h = h % 12 || 12;
  return `${h}:${min} ${period}`;
}

// Convenience for a time range: "19:00" & "22:00" → "7:00 PM–10:00 PM"
export function fmtTimeRange(start, end) {
  const s = fmtTime(start), e = fmtTime(end);
  if (!s && !e) return "";
  if (!e) return s;
  if (!s) return e;
  return `${s}–${e}`;
}

// Full datetime for created_at ISO timestamps → "MM-DD-YYYY h:MM AM/PM"
export function fmtDateTime(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return String(iso);
  const date = `${pad(d.getMonth() + 1)}-${pad(d.getDate())}-${d.getFullYear()}`;
  let h = d.getHours();
  const min = pad(d.getMinutes());
  const period = h >= 12 ? "PM" : "AM";
  h = h % 12 || 12;
  return `${date} ${h}:${min} ${period}`;
}

// Short month + day, used for calendar cells (e.g. "JUL 07").
export function fmtMonthDay(input) {
  if (!input) return { month: "", day: "" };
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(input));
  const d = m ? new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])) : new Date(input);
  if (isNaN(d.getTime())) return { month: "", day: "" };
  const month = d.toLocaleString("en-US", { month: "short" });
  return { month, day: pad(d.getDate()) };
}
